export const getFieldAnchorId = (fieldName: string): string => {
  return `field-${fieldName}`;
};